import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const stopsServiceApi = createApi({
  reducerPath: 'stopsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetStops: builder.query<any, void>({
      query: () => 'agency/stops/',
    }),
    SearchStops: builder.query<any, string>({
      query: (txt) => ({
        url: `/agency/stops-intercambiador?txt=${txt}`,
        method: 'GET',
      }),
    }),
    SearchLinesStops: builder.query<any, any>({
      query: ({ txt, type }) => ({
        url: `/agency/linesAndStops/getByTxt?txt=${txt}&searchType=${type}`,
        method: 'GET',
      }),
    }),
    PostAlarmNotificationBus: builder.mutation<any, any>({
      query: (body) =>({
        url: 'vehicle/push',
        method: 'POST',
        body: body,
      })
    }),
    SearchNominatim: builder.query<any, any>({
      query: ({ txt, language = CURRENT_LANGUAGE, page=1, perPage=4 }) =>({
        url: `/search/nominatim?locale=${language}&txt=${txt}&numPage=${page}&elementsPerPage=${perPage}`,
        method: 'GET',
      })
    }),
    SearchNominatimReverse: builder.query<any, any>({
      query: ({ lat, lng, language = CURRENT_LANGUAGE }) =>({
        url: `/search/nominatim/reverse?locale=${language}&lat=${lat}&lon=${lng}`,
        method: 'GET',
      })
    }),
  }),
});

export const {
  useLazyGetStopsQuery,
  useLazySearchStopsQuery,
  useLazySearchLinesStopsQuery,
  usePostAlarmNotificationBusMutation,
  useLazySearchNominatimQuery,
  useLazySearchNominatimReverseQuery
} = stopsServiceApi;
